/**
 * 直播间
 */

import { HTTP_ALB } from '../axios';

//  直播间管理列表-新
export const getlivelistNew = params => {
	return HTTP_ALB.get('/foundation/live_app/all', params);
};
//  直播间管理列表
export const getlivelist = params => {
	return HTTP_ALB.get('/live/app/list', params);
};

// 添加直播间管理
export const addlive = params => {
	return HTTP_ALB.post('/foundation/live_app/add', params);
};
// 获取弹幕列表
export const getLiveDanmu = params => {
	return HTTP_ALB.get('/live/live/danmu', params);
};
// 编辑直播间管理
export const editlive = params => {
	return HTTP_ALB.post('/foundation/live_app/edit', params);
};
// 删除直播间管理
export const deletelive = params => {
	return HTTP_ALB.get('/foundation/live_app/del', params);
};

// 直播间列表
export const getlive_list = params => {
	return HTTP_ALB.get('/live/live/live_list', params);
};
// 企业号直播间列表
export const getCluerich_list = params => {
	return HTTP_ALB.get('/live/cluerich/list', params);
};
// 直播间列表历史数据
export const getlive_sum = params => {
	return HTTP_ALB.get('/live/live/live_sum', params);
};

// 直播间列表 抖音企业号
export const getCluerichLivelist = params => {
	return HTTP_ALB.get('/live/cluerich/livelist', params);
};
// 直播间列表 抖音企业号
export const getCluerichDetail = params => {
	return HTTP_ALB.get('/live/cluerich/detail', params);
};

// 直播间详情数据
export const getlivebaseinfo = params => {
	return HTTP_ALB.get('/live/live/live_baseinfo', params);
};

// 直播间详情商品数据
export const getdetailliveshoplist = params => {
	return HTTP_ALB.get('/live/live/live_shop_list', params);
};

// 直播间详情投流信息数据
export const getliveadvdata = params => {
	return HTTP_ALB.get('/live/live/live_adv_data', params);
};

// 直播间详情投流信息数据
export const getLiveSphLiveSum = params => {
	return HTTP_ALB.get('live/sph/live_sum', params);
};
// 视频号 趋势数据 
export const getLiveSphTrend = params => {
	return HTTP_ALB.get('/live/sph/trend', params);
};

// 直播间详情基础数据 
export const getlivecoredata = params => {
	return HTTP_ALB.get('/live/live/live_core_data', params);
};
// 获取快手 核心数据 
export const getLiveKsCore = params => {
	return HTTP_ALB.get('/live/ks/core', params);
};
// 获取快手 趋势数据 
export const getLiveKsTrend = params => {
	return HTTP_ALB.post('/live/ks/trend', params);
};
// 获取快手 直播间列表总计数据 
export const getLiveKsSum = params => {
	return HTTP_ALB.get('/live/ks/sum', params);
};
// 获取京东 直播间列表总计数据 
export const getLiveJDSum = params => {
	return HTTP_ALB.get('/live/jd/sum', params);
};
// 获取快手 弹幕数据 
export const getLiveKsComment = params => {
	return HTTP_ALB.get('/live/ks/comment', params);
};
// 获取快手 商品数据 
export const getLiveKsProduct = params => {
	return HTTP_ALB.get('/live/ks/product', params);
};


// 直播间排班
export const getscheduled = params => {
	return HTTP_ALB.get('/foundation/live_app/scheduled', params);
};
// 直播间--排班日历--真实场次--企业号
export const getscheduledCluerich = params => {
	return HTTP_ALB.get('/live/cluerich/scheduled', params);
};

// 直播间场次修正
export const post_live_copy = params => {
	return HTTP_ALB.post('/foundation/live/copy', params);
};

// 直播间趋势数据
export const getlivetrend = params => {
	return HTTP_ALB.get('/live/live/trend', params);
};


// 直播间字段
export const postlivecache = params => {
	return HTTP_ALB.post('/live/live/cache', params);
};

// 直播间添加投流账户
export const liveaddadv = params => {
	return HTTP_ALB.post('/live/live/add/adv', params);
};

// 企业号直播间详情数据
export const getqylivebaseinfo = params => {
	return HTTP_ALB.get('/live/cluerich/baseinfo', params);
};

// 企业号直播间详情数据
export const getqylivecoredata = params => {
	return HTTP_ALB.get('/live/cluerich/coredata', params);
};
// 企业号直播间详情数据
export const getqylivetrend = params => {
	return HTTP_ALB.get('/live/cluerich/trenddata', params);
};
// 企业号直播间详情数据
export const getDataStaffFace = params => {
	return HTTP_ALB.get('/data/staff/face', params);
};

// 直播间修正
export const fixImg = params => {
	return HTTP_ALB.get('/live/face/fix', params);
};

// 投流趋势折线图
export const adv_trend = params => {
	return HTTP_ALB.get('/live/live/adv_trend', params);
};

// 京东基本数据
export const getJdCore = params => {
	return HTTP_ALB.get('/live/jd/core', params);
};

// 京东趋势数据
export const getJdTrend = params => {
	return HTTP_ALB.post('/live/jd/trend', params);
};

// 商品数据
export const getJdProduct = params => {
	return HTTP_ALB.get('/live/jd/product', params);
};